import { useCallback, useEffect, useRef, useState } from "react";

export function useDisplayOverlay(autoHideMs = 5000) {
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearTimer = useCallback(() => {
    if (!timerRef.current) return;
    clearTimeout(timerRef.current);
    timerRef.current = null;
  }, []);

  const scheduleHide = useCallback(() => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      setIsVisible(false);
      timerRef.current = null;
    }, autoHideMs);
  }, [autoHideMs, clearTimer]);

  const show = useCallback(() => {
    setIsVisible(true);
    scheduleHide();
  }, [scheduleHide]);

  const hide = useCallback(() => {
    clearTimer();
    setIsVisible(false);
  }, [clearTimer]);

  const ping = useCallback(() => {
    setIsVisible(true);
    scheduleHide();
  }, [scheduleHide]);

  useEffect(() => clearTimer, [clearTimer]);

  return { isVisible, show, hide, ping };
}
